var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInfocircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-infocircle",
    d: "M6,.5a6,6,0,1,0,6,6A6,6,0,0,0,6,.5Zm0,3a.75.75,0,1,1-.75.75A.75.75,0,0,1,6,3.5Zm.938,6H5.063a.563.563,0,0,1,0-1.125h.375v-1.5H5.25a.563.563,0,0,1,0-1.125H6a.563.563,0,0,1,.563.563V8.375h.375a.563.563,0,0,1,0,1.125Z",
    transform: "translate(0 -0.5)",
    fill: "#1890ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfocircle);
export default __webpack_public_path__ + "static/media/icon-infocircle.80509c63f5a071682f233a642bd2fe95.svg";
export { ForwardRef as ReactComponent };